import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import Modal, { Props as ModalProps } from '../../../../../Modal';
import { useTheme } from '../../../../../theme';
import { useIsMobile } from '../../../../../utils';
import { default as BaseButton } from '../../../../../BaseComponents/Button';

interface Props extends Omit<ModalProps, 'title'> {
	title?: string | React.ReactNode;
	description: string | React.ReactNode;
	cancelText?: string | React.ReactNode;
	confirmText?: string | React.ReactNode;
	onConfirm: () => void;
	hideCancel?: boolean;
}

const SureModal: React.FC<Props> = ({
	title,
	description,
	cancelText,
	confirmText,
	onConfirm,
	hideCancel,
	...props
}) => {
	const { SureModal: css } = useTheme('SeatMap');
	const { t } = useTranslation('SeatMap');

	const isMobile = useIsMobile();

	return (
		<Modal
			maxWidth="xs"
			classes={{
				...props.classes,
				scrollBody: cn(css.scrollBody, props.classes?.scrollBody),
				paper: cn(css.paper, props.classes?.paper)
			}}
			slideUp={isMobile}
			{...props}
		>
			{title && <div className={css.title}>{title}</div>}
			<div className={css.description}>{description}</div>
			<div className={css.footer}>
				{!hideCancel && (
					<BaseButton className={css.button} onClick={props.onClose}>
						{cancelText || t('Cancel')}
					</BaseButton>
				)}

				<BaseButton className={css.button} onClick={onConfirm}>
					{confirmText || t('Confirm')}
				</BaseButton>
			</div>
		</Modal>
	);
};

export default SureModal;
